/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehavioralAssessmentCto } from '../../models/behavioral-assessment-cto';

export interface GetBehavioralAssessment$Plain$Params {
  behavioralAssessmentId: string;
}

export function getBehavioralAssessment$Plain(http: HttpClient, rootUrl: string, params: GetBehavioralAssessment$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BehavioralAssessmentCto>> {
  const rb = new RequestBuilder(rootUrl, getBehavioralAssessment$Plain.PATH, 'get');
  if (params) {
    rb.path('behavioralAssessmentId', params.behavioralAssessmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BehavioralAssessmentCto>;
    })
  );
}

getBehavioralAssessment$Plain.PATH = '/behavioralAssessment/{behavioralAssessmentId}';
